import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
    label: string;
    className?: string;
    children: ReactNode;
    labelClassName?: string;
}

export function ReadOnlyField({ label, className, children, labelClassName }: Props) {
    return (
        <div className={twMerge('flex flex-col gap-1', className)}>
            <div className={twMerge('break-words text-sm text-neutral-500', labelClassName)}>{label}</div>
            <div className="break-words font-medium">{children}</div>
        </div>
    );
}
